export const CarrierBlacklistReportRoute = {
  path: '/reports/carrierblacklist',
  load: () => import('./CarrierBlacklistReport'),
  protected: true,
};
